<template>
  <div class="profile">
    <APPBAR></APPBAR>
    <v-container fluid>
      <v-row justify="center" align="center">
        <v-col >
          <h4>
            <v-icon class="mr-2" color="black">mdi-account-circle</v-icon>
            ข้อมูลบัญชีผู้ใช้
          </h4>
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-col class="text-center" lg="4" md="4" cols="8"
          ><v-img :src="profile.image" :lazy-src="profile.image"></v-img
        ></v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-col class="text-center" lg="4" md="4" cols="12">
          <v-row justify="center" align="center">
            <v-col class="text-left"><b>ชื่อผู้ใช้: </b>{{profile.name}}</v-col>
          </v-row>
          <v-row justify="center" align="center">
            <v-col class="text-left"><b>อีเมล: </b>{{profile.email}}</v-col>
          </v-row>
          <v-row justify="center" align="center">
            <v-col class="text-left"><b>การเข้าใช้งาน: </b>{{profile.login_type}}</v-col>
          </v-row>
          <v-row justify="center" align="center">
            <v-col class="text-left"><b>รหัสผู้ใช้งาน: </b>{{profile.user_id}}</v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import APPBAR from "../components/appBar";
export default {
  name: "Profile",
  components: { APPBAR },
  data: () => ({
    profile: {
      image: "",
      name: "",
      email: "",
      login_type: "",
      user_id: ""
    },
  }),
  created() {
    if (!this.$auth.isAuthenticated && !this.$auth.loading) {
      localStorage.removeItem("user_id_kanpramool");
      localStorage.removeItem("login_type_kanpramool");
      localStorage.removeItem("email_kanpramool");
      localStorage.removeItem("name_kanpramool");
      localStorage.removeItem("image_kanpramool");
      this.$router.push("/");
    } else {
      this.profile.image = localStorage.getItem("image_kanpramool");
      this.profile.name = localStorage.getItem("name_kanpramool");
      this.profile.email = localStorage.getItem("email_kanpramool");
      this.profile.login_type = localStorage.getItem("login_type_kanpramool");
      this.profile.user_id = localStorage.getItem("user_id_kanpramool");
    }
  },
};
</script>

<style>
</style>